import { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../../config/api";
import { useAuth } from "../../components/AuthProvider";
import { useI18n } from "../../i18n";
import { GovernanceListingSection } from "../../components/governance/GovernanceListingSection";
import { ComplianceCenterMetricTile } from "../../components/compliance-center/ComplianceCenterMetricTile";
import listStyles from "@/styles/pages/governance/GovernanceListing.module.scss";

export default function ComplianceCenterExecutiveWorkspace() {
  const { t } = useI18n();
  const { token } = useAuth();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const res = await fetch(API_ENDPOINTS.GRC_EXECUTIVE_SUMMARY, { headers: { Authorization: `Bearer ${token}` } });
      const json = res.ok ? await res.json().catch(() => ({})) : {};
      setData(json?.data || {});
      setLoading(false);
    };
    void load();
  }, [token]);

  return (
    <div className={listStyles.pageStack}>
      <GovernanceListingSection
        title={t("complianceCenterUi.nav.executive", "Executive & Board")}
        description={t(
          "complianceCenterUi.executiveIntro",
          "Board KPIs, executive risk posture, and readiness overview.",
        )}
      >
        {loading ? (
          <p className="text-sm text-slate-500 m-0">{t("common.loading", "Loading…")}</p>
        ) : (
          <div className={`${listStyles.metricsGrid} ${listStyles.metricsGrid4}`}>
            <ComplianceCenterMetricTile label={t("complianceCenterUi.openRisks", "Open risks")} value={Number(data?.executiveOpenRisks ?? data?.openRisks ?? 0)} tone="red" />
            <ComplianceCenterMetricTile
              label={t("complianceCenterUi.openFindings", "Open findings")}
              value={Number(data?.openFindings || 0)}
              tone="orange"
              title={t(
                "complianceCenterUi.openFindingsTooltip",
                "Open findings includes current Critical and High unique findings only.",
              )}
            />
            <ComplianceCenterMetricTile
              label={t("complianceCenterUi.overdueRemediation", "Overdue remediation")}
              value={Number(data?.overdueRemediation || 0)}
              tone="yellow"
            />
            <ComplianceCenterMetricTile
              label={t("complianceCenterUi.readinessScore", "Readiness score")}
              value={`${Number(data?.readinessScore || 0)}%`}
              tone="green"
            />
          </div>
        )}
      </GovernanceListingSection>
    </div>
  );
}
